import React, { useState } from 'react'

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Input } from '@mui/material'

type AddCustomerDomainProps = {
  open: boolean
  onAdd: (...args: any[]) => any
  onClose: (...args: any[]) => any
}

const AddCustomerDomain = ({ open, onAdd, onClose }: AddCustomerDomainProps) => {
  const [domain, setDomain] = useState('')

  const handleInputChange = e => setDomain(e.currentTarget.value)
  const handleAdd = async () => {
    if (!domain) return

    await onAdd(domain)
    onClose()
  }

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle>
        <Box sx={{ display: 'flex' }}>Add domain</Box>
      </DialogTitle>

      <DialogContent style={{ width: '500px' }}>
        <Input onChange={handleInputChange} style={{ width: '100%' }} value={domain} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleAdd}>Add domain</Button>
      </DialogActions>
    </Dialog>
  )
}

export default AddCustomerDomain
